// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GoogleMapsUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { isFinite } from 'lodash/fp';

const VALID_LAT_VALUES = [-85, 85];
const VALID_LONG_VALUES = [-180, 180];

/**
 * Check if value is in range
 * @param {Number} value
 * @param {Array<Number>} range
 */
function isInRange(value, range) {
  return value >= range[0] && value <= range[1];
}

/**
 * Check if the latitude and longitude is a valid pair
 * @param {any} lat
 * @param {any} long
 */
function isValidLatLong(lat: any, long: any) {
  const latValue = parseFloat(lat);
  const longValue = parseFloat(long);
  return (
    isFinite(latValue) &&
    isFinite(longValue) &&
    isInRange(latValue, VALID_LAT_VALUES) &&
    isInRange(longValue, VALID_LONG_VALUES)
  );
}

export default {
  isValidLatLong
};



// WEBPACK FOOTER //
// ./ui/share/components/charting/googlemaps/Izenda.GoogleMapsUtils.js